import gsap from 'gsap'

import { fadeInAnimation, SharedAnimation } from './shared'
import { Animation } from '@/types'

export const simpleAnimation = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const block = selector('[data-motion-block]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%', // start: 'top bottom',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let blockAnimation: SharedAnimation
  if (block) {
    blockAnimation = fadeInAnimation(block)
    timeline.add(blockAnimation.timeline, '<')
  }

  return () => {
    if (blockAnimation) {
      blockAnimation.revert()
    }
  }
}
